import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ISponsorshipType,
  ISponsorshipTypeState,
} from "./sponsorshiptypeModel";
import {
  createSponsorshipType,
  deleteSponsorshipType,
  getAllActiveSponsorshipType,
  getAllSponsorshipType,
  getSponsorshipTypeByID,
  sponsorshipTypeActiveInactive,
  updateSponsorshipType,
} from "./services/sponsorshiptype.services";

const initialState: ISponsorshipTypeState = {
  loading: false,
  formLoading: false,
  error: "",
  SponsorshipTypeList: [],
  SponsorshipTypeID: null,
  SponsorshipTypeDetail: {
    Title: "",
    IsActive: 1,
  },
};

const sponsorshipTypeSlice = createSlice({
  name: "sponsorshipType",
  initialState,
  reducers: {
    clearSponsorshipTypeDetails: (state) => {
      state.SponsorshipTypeDetail = initialState.SponsorshipTypeDetail;
    },
    setSponsorshipTypeID: (state, action) => {
      state.SponsorshipTypeID = action.payload;
    },
    clearSponsorshipTypeID: (state) => {
      state.SponsorshipTypeID = initialState.SponsorshipTypeID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllSponsorshipType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllSponsorshipType.fulfilled,
      (state, action: PayloadAction<ISponsorshipType[]>) => {
        state.loading = false;
        state.SponsorshipTypeList = action.payload || [];
      }
    );
    builder.addCase(getAllSponsorshipType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SponsorshipTypeList = [];
    });
    builder.addCase(getAllActiveSponsorshipType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveSponsorshipType.fulfilled,
      (state, action: PayloadAction<ISponsorshipType[]>) => {
        state.loading = false;
        state.SponsorshipTypeList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveSponsorshipType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SponsorshipTypeList = [];
    });
    builder.addCase(createSponsorshipType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createSponsorshipType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createSponsorshipType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateSponsorshipType.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateSponsorshipType.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateSponsorshipType.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteSponsorshipType.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteSponsorshipType.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteSponsorshipType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(sponsorshipTypeActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(sponsorshipTypeActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(sponsorshipTypeActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getSponsorshipTypeByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getSponsorshipTypeByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.SponsorshipTypeDetail = action.payload;
    });
    builder.addCase(getSponsorshipTypeByID.rejected, (state, action) => {
      state.formLoading = false;
      state.SponsorshipTypeDetail = initialState.SponsorshipTypeDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearSponsorshipTypeDetails,
  setSponsorshipTypeID,
  clearSponsorshipTypeID,
} = sponsorshipTypeSlice.actions;
export default sponsorshipTypeSlice.reducer;
